import styled from '@emotion/styled';

export const StyledFooter = styled.div({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  gap: 8,
  paddingTop: 20,
});
